import { render } from "./callWe.vue?vue&type=template&id=398c266d&scoped=true"
import script from "./callWe.vue?vue&type=script&lang=js"
export * from "./callWe.vue?vue&type=script&lang=js"

import "./callWe.vue?vue&type=style&index=0&id=398c266d&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398c266d"]])

export default __exports__